import { createIcon } from '@chakra-ui/icon';
import * as React from 'react';
export var CheckOutlineIcon = createIcon({
  displayName: 'CheckOutlineIcon',
  viewBox: '0 0 72 72',
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("circle", {
    cx: "36",
    cy: "36",
    fill: "none",
    r: "34",
    stroke: "currentColor",
    strokeWidth: "4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 38L28 48L52 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "4"
  }))
});
//# sourceMappingURL=CheckOutline.js.map